<template>
  <div>
    <div v-if="status === 'pending' && !restaurants?.length">
      <AtomSpinner class="w-6 mx-auto" />
    </div>
    <div v-else-if="restaurants?.length === 0">
      <AtomInfoBox
        :heading="$t('shared.noData.giftcards.heading')"
        :description="$t('shared.noData.giftcards.description')"
      />
    </div>
    <div class="grid gap-8" v-else-if="restaurants?.length">
      <div class="grid gap-3 md:gap-6 grid-cols-12" v-auto-animate>
        <div v-for="restaurant, key in restaurants" :key="restaurant.id" class="col-span-full sm:col-span-6 xl:col-span-4">
          <div class="w-full cursor-pointer" @click="useOpenPreview(restaurant.id)">
            <RestaurantsCard :position="key+1" :restaurant="restaurant" />
          </div>
        </div>
      </div>
      <div class="text-sm flex items-center gap-4" v-if="allowPagination">
        <NuxtLink :to="{ query: { paged: allowPagination ? paged+1 : paged }}" class="button-coral-outline" :class="{ 'disabled': !allowPagination }">
          {{ $t('shared.loadMore') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script async setup>
const route = useRoute()
const limit = ref(36)
const app = useAppStore()
const paged = computed(() => parseInt(route.query.paged || 1))
const offset = computed(() => (parseInt(paged.value) - 1) * limit.value)
const allowPagination = computed(() => data?.value?.data?.length === limit.value)

// Get City and City ID's from app store
const city = computed(() => app.cities?.find(city => city.slug === route.params?.city))
const cityIds = computed(() => [city.value?.id, ...city.value?.relatedCityIds || []])

// Get tag ID based on tag param (from WA tags)
const tag = computed(() => useTagBySlug(route.query?.tag))

// Fetch restaurants by City ID's
const { data, status } = await useFetch('/restaurants', { 
  key: `restaurants-${route.params?.city}`,
  baseURL: useEnv('apiBase'),
  query: {
    scope: 'bokabord.se',
    bookable: true,
    limit: limit.value,
    offset: computed(() => offset.value),
    sortBy: 'featured',
    orderBy: 'desc',
    cities: computed(() => city.value ? cityIds.value.join(',') : undefined),
    tags: computed(() => tag.value?.id),
    giftcardsEnabled: true,
  }
})

// Append rest ID's on initial load
const restaurants = ref(data.value?.data)

// Handle pagination as load more
watch(() => status.value, () => {
  if (route.query?.paged) {
    restaurants.value = useUniqueBy([...restaurants.value, ...data.value?.data], 'id')
  } else {
    window.scrollTo(0, 0)
    restaurants.value = data.value?.data
  }
})
</script>